import { type Animation, createAnimation } from '@ionic/angular';

interface AnimationOptions {
  enteringEl?: HTMLElement;
  leavingEl?: HTMLElement;
}

const supportsViewTransitions = CSS.supports('view-transition-name', 'none');

export const dissolveAnimation = (baseEl: HTMLElement, opts?: AnimationOptions): Animation => {
  // When View Transitions API is supported, make Ionic's animation instant
  // so it doesn't visually compete. The actual transition is handled by CSS.
  if (supportsViewTransitions) {
    return createAnimation().duration(0);
  }

  const rootAnimation = createAnimation().duration(500).easing('ease-in-out');

  if (opts?.enteringEl) {
    const enteringContent = opts.enteringEl.querySelector('ion-content');
    const enteringAnimation = createAnimation()
      .addElement(enteringContent || opts.enteringEl)
      .fromTo('opacity', 0, 1)
      .afterStyles({ opacity: 1 });

    rootAnimation.addAnimation(enteringAnimation);
  }

  if (opts?.leavingEl) {
    const leavingContent = opts.leavingEl.querySelector('ion-content');
    const leavingAnimation = createAnimation()
      .addElement(leavingContent || opts.leavingEl)
      .fromTo('opacity', 1, 0)
      .afterClearStyles(['opacity']);

    rootAnimation.addAnimation(leavingAnimation);
  }

  return rootAnimation;
};
